export default "__VITE_ASSET__49b6ef10__"